export var FlyoutPosition;

(function (FlyoutPosition) {
  FlyoutPosition["Leading"] = "leading";
  FlyoutPosition["Trailing"] = "trailing";
})(FlyoutPosition || (FlyoutPosition = {}));